import { ModuleWithProviders } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ContainerModes } from '®shared/container-structure/common/container-mode.constant';

import {
  CanActivateDraftListView,
  CanActivateListView,
  CanActivatePublishedListView,
  CanActivateViewListAsStudent,
  DraftListResolver,
  PublishedListResolver,
} from '../resolver';

import { ListViewComponent } from './list-view.component';

const listViewRoutes: Routes = [
  {
    path: 'view',
    pathMatch: 'full',
    canActivate: [CanActivateListView],
    data: { containerMode: ContainerModes.View },
    component: ListViewComponent,
    resolve: {
      readingListDetails: PublishedListResolver,
    },
  },
  {
    path: 'view_draft',
    pathMatch: 'full',
    canActivate: [CanActivateDraftListView],
    data: { containerMode: ContainerModes.View, isDraft: true },
    component: ListViewComponent,
    resolve: {
      readingListDetails: DraftListResolver,
    },
  },
  {
    path: 'view_published',
    pathMatch: 'full',
    canActivate: [CanActivatePublishedListView],
    data: { containerMode: ContainerModes.View, isDraft: false },
    component: ListViewComponent,
    resolve: {
      readingListDetails: PublishedListResolver,
    },
  },
  {
    path: 'view_as_student',
    pathMatch: 'full',
    canActivate: [CanActivateViewListAsStudent],
    data: { containerMode: ContainerModes.ViewAsStudent, isDraft: false },
    component: ListViewComponent,
    resolve: {
      readingListDetails: PublishedListResolver,
    },
  },
];

export const ListViewRoutingModule: ModuleWithProviders<RouterModule> =
  RouterModule.forChild(listViewRoutes);
